import React from 'react'
import { connect } from 'react-redux'
import style from './style'
import injectSheet from 'react-jss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { checkOfflineLimitsAction } from 'actions/applicationActions'
import { unfavoriteModelAction } from 'actions/cameraActions'
import { favoriteModelsSelector } from 'selectors/components'

const mapStateToProps = (state, ownProps) => ({ favoriteModels: favoriteModelsSelector(state, ownProps) })

class Favorite extends React.Component {
  state = { hovered: false }

  handleClick = _ => {
    const { id, controllerModel, favoriteModels, checkOfflineLimitsAction, unfavoriteModelAction } = this.props

    favoriteModels.includes(id) ? unfavoriteModelAction(id, controllerModel) : checkOfflineLimitsAction('favoriteModel', [id, controllerModel])
  }

  render() {
    const { props: { id, favoriteModels, classes }, state: { hovered }, handleClick } = this
    const favorited = favoriteModels.includes(id)

    return (
      <div
        className={classes.favorite}
        onMouseEnter={_ => this.setState({ hovered: true })}
        onMouseLeave={_ => this.setState({ hovered: false })}
        onClick={handleClick}
      >
        {favorited ? <FontAwesomeIcon icon='star' className={classes.favorited} /> : <FontAwesomeIcon icon={['far', 'star']} className={classes.notFavorited} />}
        <div className={classes.tooltip} style={{ display: hovered ? 'block' : 'none' }}>
          Favorite models will be shown at the top of the model list
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, { checkOfflineLimitsAction, unfavoriteModelAction })(injectSheet(style)(Favorite))



// WEBPACK FOOTER //
// ./src/components/CameraModelSelector/CameraDetailsContainer/CameraDetails/Favorite/index.js